"use client";
import React from 'react';
import '../css/SsostasnackbarPage.css';
import '../root.css';
import SEO from '../components/SEO';

function SsostasnackbarPage() {
    return (
        <>
            <SEO
                title="SSOSTA Snackbar - Logo, Menus & Food Photography | Samuel Banczík"
                description="SSOSTA Snackbar is a complete visual identity by Samuel Banczík: the logo, menu designs, food photography and marketing materials for a school cafeteria, grown to over 31,000 monthly Instagram views."
                keywords="SSOSTA Snackbar, logo, menu design, food photography, branding, visual identity, graphic design, Samuel Banczík"
                url="https://banczik.com/ssostasnackbar"
                type="article"
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "WebPage",
                    "name": "SSOSTA Snackbar Project",
                    "url": "https://banczik.com/ssostasnackbar",
                    "description": "SSOSTA Snackbar visual identity, showcasing my skills and knowledge in graphic design and photography.",
                    "breadcrumb": {
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://banczik.com/" },
                            { "@type": "ListItem", "position": 2, "name": "SSOSTA Snackbar", "item": "https://banczik.com/ssostasnackbar" }
                        ]
                    }
                }}
            />
            <div className='snackbar-container'>
                <div className='snackbar-text'>
                    <div className='snackbar-heading'>
                        <h1>BRAND <span className='special-font' style={{ fontStyle: "italic" }}>LOGO</span></h1>
                        <img src="/images/snackbar.svg" alt="SSOSTA Snackbar logo - pizza slice with the brand name" />
                        <h1><span className='special-font' style={{ fontStyle: "italic" }}>MENU</span> DESIGN</h1>
                        <div className='snackbar-menus'>
                            <img src="/images/snackbarmenu.jpg" alt="SSOSTA Snackbar monthly menu for December" />
                            <img src="/images/snackbarmenu2.jpg" alt="SSOSTA Snackbar daily menu" />
                            <img src="/images/snackbarmenu3.jpg" alt="SSOSTA Snackbar special announcement about the payment terminal replacement" />
                        </div>
                        <h1>FOOD <span className='special-font' style={{ fontStyle: "italic" }}>PHOTOGRAPHY</span></h1>
                        <div className='snackbar-photos'>
                            <img src="/images/snackbarfood.jpg" alt="SSOSTA Snackbar food photography - ham and cheese baguette" />
                            <img src="/images/snackbarfood2.jpg" alt="SSOSTA Snackbar food photography - fresh fruit cup" />
                            <img src="/images/snackbarfood3.jpg" alt="SSOSTA Snackbar food photography - croissant sandwich" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SsostasnackbarPage
